import { createFileRoute } from "@tanstack/react-router";
import { DocsLayout } from "@/shared/layouts/docs-layout";
import { HelpIndexPage } from "@/shared/pages/help";

export const Route = createFileRoute("/docs/")({
  component: DocsIndexRoute,
});

function DocsIndexRoute() {
  return (
    <DocsLayout>
      <HelpIndexPage />
    </DocsLayout>
  );
}
